import { CleaningServices as CleaningServicesIcon } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AccessControl, MuiButton } from "@ryde/controls";
import { useClearProductionCache } from "@ryde/redux";

interface IProductionClearCacheButtonProps {
  e2eData?: string;
}

export const ProductionClearCacheButton: FC<
  IProductionClearCacheButtonProps
> = ({ e2eData = "production_clear_application_cache" }) => {
  const { t } = useTranslation();
  const { handleClearProductionCacheClick } = useClearProductionCache();

  return (
    <AccessControl entity="rideProduction" action="produce">
      <MuiButton
        e2eData={e2eData}
        muiStyle="info"
        startIcon={<CleaningServicesIcon fontSize="small" />}
        onClick={() => void handleClearProductionCacheClick()}
      >
        {t("rideProduction.clearApplicationCache")}
      </MuiButton>
    </AccessControl>
  );
};
